module.exports = __webpack_public_path__ + "img/saddle-cloths-6.803cf263.svg";